export default __webpack_public_path__ + "static/media/Duudle-AI-1.1.1f53884b.jpg";